import React from "react";
import Fab from "@mui/material/Fab";
import { Link } from "react-router-dom";
import SpeedDial from "../speed-dial/SpeedDial";

const FloatingButton = ({ icon, onClick, to }) => {
  return (
    <SpeedDial>
      {to ? (
        <Link to={to}>
          <Fab
            size="medium"
            aria-label="add"
            sx={{
              position: "absolute",
              bottom: 16,
              right: 16,
              background: "#C86337",
              color: "#fff",
              ":hover": {
                background: "#C86337",
                color: "#000",
              },
            }}
          >
            {icon}
          </Fab>
        </Link>
      ) : (
        <Fab
          size="medium"
          color="primary"
          aria-label="add"
          onClick={onClick}
          sx={{
            position: "absolute",
            bottom: 16,
            right: 16,
            background: "#C86337",
            color: "#fff",
            ":hover": {
              background: "#C86337",
              color: "#000",
            },
          }}
        >
          {icon}
        </Fab>
      )}
    </SpeedDial>
  );
};

export default FloatingButton;
